// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html section#firebaseui-auth-container button{box-shadow:none;background-color:#e9e9e9!important;border-radius:8px}html section#firebaseui-auth-container button:hover{background-color:#cecece!important}html section#firebaseui-auth-container button:active{background-color:#666!important}", ""]);
// Exports
module.exports = exports;
